import { Field } from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import { NativeSelect } from '@/components/ui/native-select'
import type { FilterKey, GroupFilters, MarketingList } from './api'
import { FILTERS, FILTER_ORDER, choices, cleanFilters } from './format'

/** Pick who a marketing email goes to, with the customer list's filters. */
export function FilterFields({
  filters,
  meta,
  onChange,
  disabled = false,
  idPrefix = 'mkt',
}: {
  filters: GroupFilters
  meta: MarketingList['meta']
  onChange: (filters: GroupFilters) => void
  disabled?: boolean
  idPrefix?: string
}) {
  const set = (key: FilterKey, value: string) => onChange(cleanFilters({ ...filters, [key]: value }))

  return (
    <div className="grid gap-3">
      {FILTER_ORDER.map((key) => (
        <Field key={key} label={FILTERS[key].label} htmlFor={`${idPrefix}-${key}`}>
          <NativeSelect
            id={`${idPrefix}-${key}`}
            disabled={disabled}
            value={filters[key] ?? (key === 'who' ? 'owners' : '')}
            onChange={(e) => set(key, e.target.value)}
          >
            {key !== 'who' && <option value="">{FILTERS[key].any}</option>}
            {choices(key, meta).map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </NativeSelect>
        </Field>
      ))}
      <Field
        label="Customer tag"
        htmlFor={`${idPrefix}-tag`}
        hint="A tag from the customer page, such as agency."
      >
        <Input
          id={`${idPrefix}-tag`}
          disabled={disabled}
          value={filters.tag ?? ''}
          onChange={(e) => set('tag', e.target.value)}
        />
      </Field>
    </div>
  )
}
